.calloutContainer {
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 0px;
}

.calloutContainer > div {
  align-items: center;
}

.calloutContainer > a:first-of-type {
  margin-left: 4px;
}

.calloutContainer:has(.calloutButton) > :nth-last-child(2) {
  margin-right: 32px;
}

.calloutButton {
  margin-left: auto;
  width: auto;
}

@media (--reefer-media-tablet-max) {
  .calloutContainer__mobile {
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px;
  }

  .calloutContainer__mobile > div {
    align-items: start;
  }

  .calloutContainer__mobile > a {
    margin-left: 0;
  }

  .calloutContainer:has(.calloutButton) > :nth-last-child(2) {
    margin-right: 0;
  }

  .calloutContainer__mobile > .calloutButton {
    margin-left: 0;
    width: 100%;
  }
}

.boxShadow {
  box-shadow: var(--shadows-hard);
}
